const state = {
  itens: []
}

const getters = {
  getItens(state) {
    return state.itens
  }
}

const mutations = {
  adicionarTodos(state, marcas) {
    state.itens = marcas
  },
  adicionar(state, marca) {
    state.itens.push(marca)
  },
  remover(state, marca) {
    state.itens = state.itens.filter(item => item !== marca)
  },
  resetar(state) {
    state.itens = []
  }
}

const actions = {
  adicionarTodos: ({ commit }, marcas) => {
    commit("adicionarTodos", marcas)
  },
  adicionar: ({ commit }, marca) => {
    commit("adicionar", marca)
  },
  remover: ({ commit }, marca) => {
    commit("remover", marca)
  },
  resetar: ({ commit }) => {
    commit("resetar")
  }
}

export default { namespaced: true, state, mutations, getters, actions }
